"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTokenFromInterceptedOAuthRedirect = void 0;
const react_1 = require("react");
const react_query_1 = require("react-query");
const react_router_dom_1 = require("react-router-dom");
const useCodeChallenge_1 = require("./useCodeChallenge");
const useOAuthState_1 = require("./useOAuthState");
function useTokenFromInterceptedOAuthRedirect(client, logoutUrl, realm) {
    const history = react_router_dom_1.useHistory();
    const params = useOAuthUrlParams();
    const { reset: resetCodeChallenge, codeVerifier } = useCodeChallenge_1.useCodeChallenge();
    const isIntercepting = !!(params && codeVerifier && client);
    const _a = react_query_1.useQuery(['oauth-token-interception', params, codeVerifier, realm], () => {
        return client.code.getToken(window.location.href, {
            redirectUri: `${window.location.origin}${params.state.pathname}${params.state.search}`,
            body: { code_verifier: codeVerifier },
        });
    }, { enabled: isIntercepting && !!codeVerifier }), { data: interceptedToken, error: getTokenError } = _a, res = __rest(_a, ["data", "error"]);
    const gotResult = !!interceptedToken || !!getTokenError;
    const [token, setToken] = react_1.useState(null);
    react_1.useEffect(() => {
        if (interceptedToken) {
            setToken(interceptedToken);
        }
    }, [interceptedToken]);
    const [error, setError] = react_1.useState(null);
    react_1.useEffect(() => {
        if (getTokenError) {
            setError(getTokenError);
        }
    }, [getTokenError]);
    react_1.useEffect(() => {
        if (!!gotResult) {
            resetCodeChallenge();
        }
    }, [gotResult, resetCodeChallenge]);
    react_1.useEffect(() => {
        if (gotResult && params) {
            history.push(`${params.state.pathname}${params.state.search}`);
        }
    }, [history, gotResult, params]);
    const clear = react_1.useCallback(() => {
        setToken(null);
        setError(null);
        setTimeout(() => {
            if (logoutUrl) {
                window.location.href = logoutUrl;
            }
        }, 200);
    }, [logoutUrl]);
    return react_1.useMemo(() => (Object.assign(Object.assign({}, res), { error: error !== null && error !== void 0 ? error : getTokenError, token: token !== null && token !== void 0 ? token : null, isIntercepting,
        clear })), [res, error, getTokenError, token, isIntercepting, clear]);
}
exports.useTokenFromInterceptedOAuthRedirect = useTokenFromInterceptedOAuthRedirect;
function useOAuthUrlParams() {
    const { search } = react_router_dom_1.useLocation();
    const searchParams = react_1.useMemo(() => new URLSearchParams(search), [search]);
    const code = react_1.useMemo(() => searchParams.get('code'), [searchParams]);
    const stateString = react_1.useMemo(() => searchParams.get('state'), [searchParams]);
    const state = react_1.useMemo(() => {
        if (!stateString) {
            return null;
        }
        try {
            return useOAuthState_1.parseState(stateString);
        }
        catch (_a) {
            return null;
        }
    }, [stateString]);
    return react_1.useMemo(() => (!code || !state ? null : { code, state }), [code, state]);
}
//# sourceMappingURL=useTokenFromInterceptedOAuthRedirect.js.map